const HELP_WIDGET_LOCATION_HISTORY_LOCAL_STORAGE_KEY =
  "help-widget-location-history";
const TOP_LEVEL_LOCATIONS = ["/", "/conversations", "/help", "/explore"];
const HELP_WIDGET_LAST_ACTIVITY_TIMESTAMP_KEY =
  "help-widget-last-activity-timestamp";
const HISTORY_EXPIRY_MS = 48 * 60 * 60 * 1000;

export const isHistoryExpired = (): boolean => {
  try {
    const lastActivityTimestamp = localStorage.getItem(
      HELP_WIDGET_LAST_ACTIVITY_TIMESTAMP_KEY,
    );

    if (!lastActivityTimestamp) {
      return false;
    }

    const now = Date.now();
    const timeDiff = now - Number(lastActivityTimestamp);

    return timeDiff > HISTORY_EXPIRY_MS;
  } catch {
    return false;
  }
};

export const getHistory = (): string[] => {
  try {
    const stored = localStorage.getItem(
      HELP_WIDGET_LOCATION_HISTORY_LOCAL_STORAGE_KEY,
    );

    if (!stored) {
      return ["/"];
    }

    // Check if timestamp exists and if 48 hours have passed
    if (isHistoryExpired()) {
      clearHistory();
      return ["/"];
    }

    return JSON.parse(stored);
  } catch {
    return ["/"];
  }
};

const setHistory = (history: string[]): void => {
  localStorage.setItem(
    HELP_WIDGET_LOCATION_HISTORY_LOCAL_STORAGE_KEY,
    JSON.stringify(history),
  );
  localStorage.setItem(
    HELP_WIDGET_LAST_ACTIVITY_TIMESTAMP_KEY,
    String(Date.now()),
  );
};

export const pushLocation = (location: string): void => {
  const history = getHistory();

  // Don't add duplicate consecutive locations
  if (history[history.length - 1] !== location) {
    // If pushing a top-level location, clear history and start fresh
    if (TOP_LEVEL_LOCATIONS.includes(location)) {
      setHistory([location]);
    } else {
      history.push(location);
      setHistory(history);
    }
  }
};

export const popLocation = (): string => {
  const history = getHistory();

  if (history.length <= 1) {
    return "/"; // Can't go back from root, return root
  }

  history.pop(); // Remove current location
  setHistory(history);

  return history[history.length - 1] || "/";
};

export const clearHistory = (): void => {
  setHistory(["/"]);
};
